var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 0.5H2.0202C0.904475 0.5 0 1.39543 0 2.5V14.5C0 15.6046 0.904475 16.5 2.0202 16.5H22.2222C23.3379 16.5 24.2424 15.6046 24.2424 14.5V2.5C24.2424 1.39543 23.3379 0.5 22.2222 0.5Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09091 13.5C11.8802 13.5 14.1414 11.2614 14.1414 8.5C14.1414 5.73858 11.8802 3.5 9.09091 3.5C6.30159 3.5 4.04041 5.73858 4.04041 8.5C4.04041 11.2614 6.30159 13.5 9.09091 13.5Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1515 13.5C17.9408 13.5 20.202 11.2614 20.202 8.5C20.202 5.73858 17.9408 3.5 15.1515 3.5C12.3621 3.5 10.101 5.73858 10.101 8.5C10.101 11.2614 12.3621 13.5 15.1515 13.5Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1212 4.49951C13.3479 5.41172 14.1414 6.86406 14.1414 8.49988C14.1414 10.1357 13.3479 11.588 12.1212 12.5002C10.8944 11.588 10.101 10.1357 10.101 8.49988C10.101 6.86406 10.8944 5.41172 12.1212 4.49951Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.6ffaec680558a979a17dc03186f49964.svg";
export { ForwardRef as ReactComponent };